import { MenuListProps } from '@mui/material'
import { useMemo } from 'react'
import { CARD_HEIGHT } from '../constants'

export function useMenuListProps(): MenuListProps {
  const sx = useMemo(
    () => ({
      maxHeight: CARD_HEIGHT,
      overflowY: 'auto',
    }),
    [],
  )

  return { sx, role: 'menu' }
}
